import React from 'react';
import { func } from 'prop-types';

import Form from '../Form';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';
import PasswordInput from 'elements/Inputs/PasswordInput';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';
import CheckBox from 'elements/Inputs/CheckBox';
import { SectionHeader, BottomActionCall } from '../Layout';

import styles from './LoginForm.css';

const  LoginForm = ({ onSubmit }) => (
  <Form className={styles.loginForm} onSubmit={onSubmit}>
    <SectionHeader title='Sign in to your Account.' />

    <FormField>
      <InputField label="Email" validations={['required', 'email']} />
      <CheckBox table className="email-remember" label="Remember Email" />
    </FormField>


    <FormField>
      <PasswordInput label="Password" customClasses="withIcon" validations={['required', 'password']} />
    </FormField>

    <Button>Login</Button>
    <LinkFreeStanding className="recovery-link" size="s">Forgot Credenttials?</LinkFreeStanding>
    <BottomActionCall
      icon="exit"
      text="New to Airtel Global Voice?"
      linkText="create account"
    />
  </Form>
);

LoginForm.propTypes = {
  onSubmit: func,
};

LoginForm.displayName = 'LoginForm';

export default LoginForm;



// WEBPACK FOOTER //
// ./src/uis/components/Form/LoginForm/LoginForm.js